module.exports = __webpack_public_path__ + "static/logo3-9ae932a73b7b015211438430f3c7f544.png";